$(document).ready(function () {

    // Prevent right click on images
    $('body').on('contextmenu', 'img', function (e) {
        return false;
    });

    // Fix for dropdown-menu
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        var $el = $(this);
        var $parent = $(this).offsetParent(".dropdown-menu");
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');

        $(this).parent('li').toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-menu .show').removeClass("show");
        });

        if (!$parent.parent().hasClass('navbar-nav')) {
            $el.next().css({ "top": $el[0].offsetTop, "left": $parent.outerWidth() - 4 });
        }

        return false;
    });

    // Load content in sites modal
    $('#SitesModal').on('shown.bs.modal', function () {
        $.get('/Partials/LanguagesAndSites', function (data) {
            $('#SitesModal .modal-body').html(data);
        });
    });

    // Focus on search field
    $('#SearchModal').on('shown.bs.modal', function () {
        $('#InputSearchModal').trigger('focus');
    });
            
    // Initiate scroll menu
    $('nav.navbar-main').scrollmenu();

    // Initate to top
    $('#to-top').totop();

    $('form.download-filter').spmdownloads();

    $('body.product-page').spmproductpage();
});


$(window).scroll(function () {
    if ($('nav.navbar-main').data('scrollmenu')) {
        $('nav.navbar-main').data('scrollmenu').scrolling();
    }

    if ($('#to-top').data('totop')) {
        $('#to-top').data('totop').scrolling();
    }
});

$(window).resize(function () {
    if ($('nav.navbar-main').data('scrollmenu')) {
        $('nav.navbar-main').data('scrollmenu').resize();
    }

    if ($('#to-top').data('totop')) {
        $('#to-top').data('totop').resize();
    }
});